import {IQuestionElements} from '../../../../../incase-domain/elements/question';
import {QuestionAnswerEnum, QuestionAnswerType} from '../../../../../incase-domain/analytics';

export const getAnswerStatus = (question: IQuestionElements, answerText: string): QuestionAnswerType => {
    if (answerText === 'All correct') {
        return QuestionAnswerEnum.ALL_CORRECT;
    }

    const originalAnswer = 'answers' in question ? question.answers?.find((answer) => answer.text === answerText) : undefined;

    if (originalAnswer?.type === 'debatable') {
        return QuestionAnswerEnum.DEBATABLE;
    }

    if (originalAnswer?.type === 'correct') {
        return QuestionAnswerEnum.CORRECT;
    }

    return QuestionAnswerEnum.INCORRECT;
};
